module.exports = __webpack_public_path__ + "71e02e7adb44e6348a4f3c3d9829b2a0.mp4";